import { authenticatedDelete } from './request';

export const deleteDoctorAccount = async (id, setErrorMessage) => {
  const onFail = () => setErrorMessage('Ocurrió un error eliminando la cuenta del doctor.');
  const url = `/doctor-data/delete/${id}`;
  return await authenticatedDelete(url, onFail);
};

export const deletePatientAccount = async (id, setErrorMessage) => {
  const onFail = () => setErrorMessage('Ocurrió un error eliminando la cuenta del paciente.');
  const url = `/auth/delete/${id}`;
  return await authenticatedDelete(url, onFail);
};

